<div class="flex flex-col md:flex-row flex-auto gap-8 p-4 h-[85vh] lg:h-[65vh]">

    <!-- Left Column: Story List -->
    <div class="w-full md:w-80 lg:w-96 flex-shrink-0 flex flex-col border rounded-lg">
        <!-- Add New Story Section -->
        <div class="p-4 border-b flex-shrink-0" *ngIf="!reviewMode">
            <h3 class="text-lg font-medium mb-4">Add a New Story</h3>
            <div class="flex items-start gap-4">
                <mat-form-field class="flex-auto" [subscriptSizing]="'fixed'">
                    <mat-label>Select Story Type</mat-label>
                    <mat-select [(ngModel)]="newStoryTypeId">
                        <mat-option *ngFor="let stType of storyGroup.ar_storytypes" [value]="stType.id_storytype">
                            {{ stType.ds_label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <button
                    class="mt-1"
                    (click)="addStory()"
                    [disabled]="!newStoryTypeId"
                    mat-flat-button
                    color="primary">
                    <mat-icon svgIcon="feather:plus-circle"></mat-icon>
                    <span class="ml-2 hidden sm:inline">Add</span>
                </button>
            </div>
        </div>

        <!-- Stories List (Scrollable) -->
        <div class="flex-auto overflow-y-auto">
            <div
                *ngFor="let story of storyGroup.ar_items"
                class="group flex items-center justify-between p-4 cursor-pointer border-b last:border-b-0 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors duration-200"
                [ngClass]="{'bg-primary-50 dark:bg-primary-900/50': story === selectedStory}"
                (click)="selectStory(story)">
                <div class="flex-auto">
                    <div class="font-medium text-base truncate">{{ story.ds_name || 'Untitled Story' }}</div>
                    <div class="text-sm text-secondary">{{ getStoryTypeName(story.id_storytype) }}</div>
                </div>
                <button
                    *ngIf="!reviewMode"
                    mat-icon-button
                    color="warn"
                    class="flex-shrink-0 ml-2 opacity-50 group-hover:opacity-100 transition-opacity"
                    (click)="removeStory(story, $event)">
                    <mat-icon class="!w-5 !h-5" svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Right Column: Story Detail / Editor (Scrollable) -->
    <div class="flex-auto rounded-lg border overflow-y-auto">
        <!-- Placeholder View when no story is selected -->
        <div *ngIf="!selectedStory" class="flex flex-col items-center justify-center h-full text-secondary p-8">
            <mat-icon svgIcon="heroicons_outline:document-text" class="!w-16 !h-16"></mat-icon>
            <p class="mt-4 text-lg text-center">Select a story from the list to edit</p>
            <p class="text-center" *ngIf="!reviewMode">Or, add a new story to get started.</p>
        </div>

        <!-- Editor View when a story is selected -->
        <div *ngIf="selectedStory" class="p-6 md:p-8">
            <div class="flex flex-col xl:flex-row gap-8">
                <!-- Left side of editor: Fields & Description -->
                <div class="flex-auto">
                    <div class="flex flex-col sm:flex-row sm:items-start gap-4 mb-6">
                        <mat-form-field class="flex-auto" floatLabel="always">
                            <mat-label>Story Name</mat-label>
                            <input
                                matInput
                                placeholder="Enter a name for the story"
                                maxlength="250"
                                [readonly]="reviewMode"
                                [(ngModel)]="selectedStory.ds_name"
                                (keyup)="onKeyupAutosave()">
                        </mat-form-field>
                    </div>

                    <div class="flex flex-col sm:flex-row gap-4 mb-6">
                        <mat-form-field class="flex-auto" [subscriptSizing]="'fixed'">
                            <mat-label>Story Type</mat-label>
                            <mat-select
                                [(ngModel)]="selectedStory.id_storytype"
                                (selectionChange)="save.emit()">
                                <mat-option *ngFor="let stType of storyGroup.ar_storytypes" [value]="stType.id_storytype">
                                    {{ stType.ds_label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w-full sm:w-28 shrink-0" floatLabel="always">
                            <mat-label>Order</mat-label>
                            <input
                                [readonly]="reviewMode"
                                (keyup)="onKeyupAutosave()"
                                placeholder="e.g. 1"
                                type="number"
                                matInput
                                [(ngModel)]="selectedStory.vi_order">
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-label>Description</mat-label>
                        <quill-editor
                            class="mt-2 w-full"
                            [readOnly]="reviewMode"
                            (onEditorCreated)="onEditorCreated($event)"
                            (onContentChanged)="onKeyupAutosave()"
                            [(ngModel)]="selectedStory.tx_description"
                            [bounds]="'self'"
                            [modules]="quillModules"
                            [formats]="quillFormats"
                            appEditableQuillHtml
                            appEditableQuillHtmlButtonText="Source">
                        </quill-editor>
                    </div>
                </div>

                <!-- Right side of editor: Image -->
                <div class="w-full xl:w-80 flex-shrink-0">
                    <mat-label>Image</mat-label>
                    <div class="relative mt-2">
                        <img
                            alt="Story Image"
                            [src]="selectedStory.im_media"
                            class="object-cover rounded-lg aspect-square w-full">
                        <button
                            class="absolute bottom-2 right-2"
                            mat-mini-fab
                            color="accent"
                            *ngIf="!reviewMode"
                            (click)="onFileInputClick(selectedStory.id_destinationstory)">
                            <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                        </button>
                    </div>
                    <input
                        hidden
                        type="file"
                        [id]="'FileUpload' + selectedStory.id_destinationstory"
                        name="fileUpload"
                        accept="image/*"
                        (change)="onChangeFile($event, selectedStory)">
                </div>
            </div>
        </div>
    </div>
</div>
